import { asyncParagraphType } from '../../components/paragraph-types/async-paragraph-type'
import ParagraphTypeSignCalculator from './theme/ParagraphTypeVueComponent/ParagraphTypeSignCalculator.vue'

const ParagraphTypeIconyTeaserGroup = asyncParagraphType('IconyTeaserGroup', {
  deferPreload: true,
  loader: () => import('./theme/ParagraphTypeVueComponent/ParagraphTypeIconyTeaserGroup.vue'),
  hydrateBeforeVisible: true,
  modulePath: 'apps/astrowoche/theme/ParagraphTypeVueComponent/ParagraphTypeIconyTeaserGroup.vue'
})
const registerBrandVueComponents = (app) => {
  app.component('ParagraphTypeIconyTeaserGroup', ParagraphTypeIconyTeaserGroup)
  app.component('ParagraphTypeSignCalculator', ParagraphTypeSignCalculator)
}

export {
  registerBrandVueComponents
}
